import React from 'react';
import { Link } from 'react-router-dom';
import HamburgerMenu from './HamburgerMenu';

const ADMIN_TILES = [
  {
    key: 'manage-users',
    to: '/manage-users',
    icon: '⚙️👥',
    title: 'Manage Users',
    description: 'Create, edit, and assign user roles',
  },
  {
    key: 'account-requests',
    to: '/account-requests',
    icon: '📨',
    title: 'Account Requests',
    description: 'Review and approve account requests',
  },
  {
    key: 'aircraft-admin',
    to: '/aircraft-admin',
    icon: '⚙️✈️',
    title: 'Edit Aircraft Info',
    description: 'Manage aircraft records and details',
  },
  {
    key: 'ampt-admin',
    to: '/ampt-admin',
    icon: '⚙️📈',
    title: 'A.M.P.T Admin',
    description: 'Configure priority percentages',
  },
  {
    key: 'adsb-admin',
    to: '/adsb-admin',
    icon: '⚙️🗺️',
    title: 'ADSB Map Admin',
    description: 'RapidAPI key & aircraft filters',
  },
  {
    key: 'historical-cdrls',
    to: '/historical-cdrls',
    icon: '📋',
    title: 'Historical CDRLs',
    description: 'View and download historical CDRLs',
  },
  {
    key: 'upload-checklist',
    to: '/upload-checklist',
    icon: '📤',
    title: 'Upload Checklist',
    description: 'Upload and manage checklist files',
  },
  {
    key: 'part-tracking',
    to: '/part-tracking',
    icon: '�',
    title: 'Part Tracking',
    description: 'Monitor and manage canned parts',
  },
];

const getStyles = (theme) => {
  const isDark = theme === 'dark';
  const colors = {
    text: isDark ? '#e0e0e0' : '#212529',
    border: isDark ? '#444' : '#dee2e6',
    cardBg: isDark ? '#2a2a2a' : '#f8f9fa',
    containerBg: isDark ? '#121212' : '#fff',
    background: isDark ? '#1e1e1e' : '#fff',
  };

  return {
    container: {
      width: '90%',
      maxWidth: '1400px',
      margin: '20px auto',
      fontFamily: 'sans-serif',
      color: colors.text,
      backgroundColor: colors.containerBg,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '30px',
      flexWrap: 'wrap',
      gap: '10px',
    },
    welcomeSection: {
      backgroundColor: colors.cardBg,
      padding: '20px',
      borderRadius: '8px',
      marginBottom: '30px',
      border: `1px solid ${colors.border}`,
    },
    tilesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '15px',
    },
    actionCard: {
      backgroundColor: colors.cardBg,
      padding: '20px',
      borderRadius: '8px',
      border: `1px solid ${colors.border}`,
      textAlign: 'center',
      textDecoration: 'none',
      color: colors.text,
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    },
    actionIcon: {
      fontSize: '2rem',
      marginBottom: '10px',
    },
    actionTitle: {
      fontSize: '1.1rem',
      fontWeight: 'bold',
      marginBottom: '5px',
    },
    actionDescription: {
      fontSize: '0.9rem',
      opacity: 0.8,
    },
    themeToggleButton: {
      padding: '8px 12px',
      border: `1px solid ${colors.border}`,
      borderRadius: '4px',
      backgroundColor: colors.background,
      color: colors.text,
      cursor: 'pointer',
      marginRight: '10px',
    },
  };
};

function AdminDashboardPage({ theme, toggleTheme }) {
  const styles = getStyles(theme);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <HamburgerMenu theme={theme} />
        <h1 style={{ flexGrow: 1, textAlign: 'center' }}>Admin Dashboard</h1>
        {toggleTheme && (
          <button onClick={toggleTheme} style={styles.themeToggleButton}>
            {theme === 'light' ? '🌙 Dark' : '☀️ Light'}
          </button>
        )}
        <div style={{ width: '45px' }}></div>
      </div>

      <div style={styles.welcomeSection}>
        <h2 style={{ marginTop: 0 }}>Administration</h2>
        <p style={{ marginBottom: 0 }}>
          Staff tools for users, aircraft, configuration, and data management.
        </p>
      </div>

      <div style={styles.tilesGrid}>
        {ADMIN_TILES.map((tile) => (
          <Link key={tile.key} to={tile.to} style={styles.actionCard}>
            <div style={styles.actionIcon}>{tile.icon}</div>
            <div style={styles.actionTitle}>{tile.title}</div>
            <div style={styles.actionDescription}>{tile.description}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default AdminDashboardPage;
